module.exports = __webpack_public_path__ + "img/banner_ABOUTUS.0d5b05c6.jpg";